"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddedNotification = exports.EmbeddedNotificationType = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Accordion_1 = tslib_1.__importDefault(require("@material-ui/core/Accordion"));
var AccordionSummary_1 = tslib_1.__importDefault(require("@material-ui/core/AccordionSummary"));
var AccordionDetails_1 = tslib_1.__importDefault(require("@material-ui/core/AccordionDetails"));
var Typography_1 = tslib_1.__importDefault(require("@material-ui/core/Typography"));
var ExpandMore_1 = tslib_1.__importDefault(require("@material-ui/icons/ExpandMore"));
var EmbeddedNotification_style_1 = require("./EmbeddedNotification.style");
var EmbeddedNotificationType;
(function (EmbeddedNotificationType) {
    EmbeddedNotificationType["warning"] = "warning";
    EmbeddedNotificationType["error"] = "error";
    EmbeddedNotificationType["information"] = "information";
    EmbeddedNotificationType["success"] = "success";
})(EmbeddedNotificationType = exports.EmbeddedNotificationType || (exports.EmbeddedNotificationType = {}));
var EmbeddedNotification = function (_a) {
    var title = _a.title, body = _a.body, type = _a.type, name = _a.name, expanded = _a.expanded, _b = _a.isExpandable, isExpandable = _b === void 0 ? true : _b, onChange = _a.onChange;
    var classes = (0, EmbeddedNotification_style_1.useEmbeddedNotificationStyles)();
    return (react_1.default.createElement(Accordion_1.default, { "data-signa": "embedded-notification-".concat(type, "-").concat(name), className: "".concat(classes.root, " ").concat(classes[type]), expanded: expanded, onChange: onChange, elevation: 0 },
        react_1.default.createElement(AccordionSummary_1.default, { expandIcon: isExpandable && react_1.default.createElement(ExpandMore_1.default, { className: classes.iconExpand }), classes: {
                expanded: classes.summaryExpanded,
                root: classes.summary,
                content: classes.summaryContent,
                expandIcon: classes.expandIcon,
            }, "aria-controls": "".concat(name, "-content"), id: "".concat(name, "-header") },
            react_1.default.createElement("span", { "data-signa": "embedded-notification-title-".concat(name), className: classes.title },
                react_1.default.createElement(Typography_1.default, { variant: "body2", className: "".concat(classes[type]) }, title))),
        react_1.default.createElement(AccordionDetails_1.default, { "data-signa": "embedded-notification-body-".concat(name), className: classes.details },
            react_1.default.createElement(Typography_1.default, { component: "div", variant: "body2", className: "".concat(classes[type]) }, body))));
};
exports.EmbeddedNotification = EmbeddedNotification;
